import entityReducer from './generators/entityReducer'
import * as types from '../actions/action-types'
import * as entityTypes from './generators/entities'

export default entityReducer('countries', {
  [entityTypes.ENTITIES_FETCH_BEGIN]: types.COUNTRIES_FETCH_BEGIN,
  [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.COUNTRIES_FETCH_SUCCEEDED,
  [entityTypes.ENTITIES_FETCH_FAILED]: types.COUNTRIES_FETCH_FAILED,
})
